module.exports = __webpack_public_path__ + "static/media/Logo.812dd760.svg";